import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/context/ThemeProvider";

export const ThemeToggle = () => {
    const { theme, setTheme } = useTheme();

    const handleToggle = () => {
        const newTheme = theme === "dark" ? "light" : "dark";
        console.log("Toggling theme from", theme, "to", newTheme);
        setTheme(newTheme);
    };

    return (
        <button
            onClick={handleToggle}
            className="hover:bg-muted mt-4 flex items-center gap-2 rounded-md px-2 py-1 text-sm transition"
            aria-label="Toggle dark mode"
            type="button"
        >
            {theme === "dark" ? (
                <Sun className="h-4 w-4" />
            ) : (
                <Moon className="h-4 w-4" />
            )}
            {theme === "dark" ? "Light" : "Dark"} Mode
        </button>
    );
};
